import { styled } from 'styled-components'

export const WeekPickerPanelWrapper = styled.div``
